// Datos de pricing replicados de Dashbo - Web/includes/pricing.php
// Fuente de precios: https://docs.google.com/spreadsheets/d/1-pC5qiiVyGfT_4kjgRq38gBFty_RGF5kw0JqnlRmaho/edit

export const PERIODS = {
    yearly: { discount: 30 },
    semestral: { discount: 20 },
    trimestral: { discount: 10 },
    monthly: { discount: 0 },
};

export const LOOKER_PRICES = {
    profesional: {
        usd: { monthly: 25, trimestral: 23, semestral: 20, yearly: 18 },
        ars: { monthly: 20494, trimestral: 18445, semestral: 16395, yearly: 14346 },
    },
    agency: {
        usd: { monthly: 50, trimestral: 45, semestral: 40, yearly: 35 },
        ars: { monthly: 40988, trimestral: 36889, semestral: 32790, yearly: 28692 },
    },
    big_agency: {
        usd: { monthly: 100, trimestral: 90, semestral: 80, yearly: 70 },
        ars: { monthly: 81976, trimestral: 73778, semestral: 65581, yearly: 57383 },
    },
    epic_agency: {
        usd: { monthly: 175, trimestral: 158, semestral: 140, yearly: 123 },
        ars: { monthly: 143458, trimestral: 129112, semestral: 114766, yearly: 100421 },
    },
};

export function getLookerPrice(planId, currency, period) {
    const plan = LOOKER_PRICES[planId];
    if (!plan) return 0;
    return plan[currency.toLowerCase()][period];
}

export const PLANS = [
    {
        id: 'profesional',
        nameKey: 'upgrade_to_dashbo.plans.profesional.name',
        descriptionKey: 'upgrade_to_dashbo.plans.profesional.description',
        prices: {
            usd: { monthly: 50, trimestral: 45, semestral: 40, yearly: 35 },
            ars: { monthly: 81976, trimestral: 73778, semestral: 65581, yearly: 57383 },
        },
        features: {
            adAccounts: 30,
            urlChecks: 10,
            sheetExports: 1,
            budgets: 120,
            multiCurrency: false,
            adminUsers: false,
            flexIndicators: false,
            chatAlerts: false,
            adgroupLevel: false,
            multiAgencies: false,
            customerSuccess: false,
            training: false,
            apiAccess: false,
            portalClientes: 1,
        },
        displayFeatures: [
            { key: 'ad_accounts', labelKey: 'subscription_features.ad_accounts_30', included: true },
            { key: 'url_checks', labelKey: 'subscription_features.url_checks_10', included: true },
            { key: 'sheet_exports', labelKey: 'subscription_features.sheet_exports_1', included: true },
            { key: 'budgets', labelKey: 'subscription_features.budgets_120', included: true },
            { key: 'multi_currency', labelKey: 'subscription_features.multi_currency', included: false },
            { key: 'admin_users', labelKey: 'subscription_features.admin_users', included: false },
            { key: 'portal_clientes', labelKey: 'subscription_features.portal_clientes_1', included: true, highlight: true, type: 'callout', subtitleKey: 'subscription_features.portal_clientes_subtitle' },
        ],
    },
    {
        id: 'agency',
        nameKey: 'upgrade_to_dashbo.plans.agency.name',
        descriptionKey: 'upgrade_to_dashbo.plans.agency.description',
        inheritsFrom: 'upgrade_to_dashbo.plans.profesional.name',
        prices: {
            usd: { monthly: 100, trimestral: 90, semestral: 80, yearly: 70 },
            ars: { monthly: 163952, trimestral: 147557, semestral: 131162, yearly: 114766 },
        },
        features: {
            adAccounts: 70,
            urlChecks: 10,
            sheetExports: 10,
            budgets: null, // ilimitados
            multiCurrency: true,
            adminUsers: true,
            flexIndicators: true,
            chatAlerts: true,
            adgroupLevel: false,
            multiAgencies: false,
            customerSuccess: false,
            training: true,
            apiAccess: false,
            portalClientes: 25,
        },
        displayFeatures: [
            { key: 'ad_accounts', labelKey: 'subscription_features.ad_accounts_70', included: true },
            { key: 'sheet_exports', labelKey: 'subscription_features.sheet_exports_10', included: true },
            { key: 'budgets', labelKey: 'subscription_features.budgets_unlimited', included: true },
            { key: 'multi_currency', labelKey: 'subscription_features.multi_currency', included: true },
            { key: 'admin_users', labelKey: 'subscription_features.admin_users', included: true },
            { key: 'flex_indicators', labelKey: 'subscription_features.flex_indicators', included: true },
            { key: 'chat_alerts', labelKey: 'subscription_features.chat_alerts', included: true },
            { key: 'training', labelKey: 'subscription_features.training', included: true },
            { key: 'data_explorer', labelKey: 'subscription_features.data_explorer', included: true, highlight: true, type: 'callout', subtitleKey: 'subscription_features.data_explorer_subtitle' },
            { key: 'portal_clientes', labelKey: 'subscription_features.portal_clientes_25', included: true, highlight: true, type: 'callout', subtitleKey: 'subscription_features.portal_clientes_subtitle' },
        ],
    },
    {
        id: 'big_agency',
        nameKey: 'upgrade_to_dashbo.plans.big_agency.name',
        descriptionKey: 'upgrade_to_dashbo.plans.big_agency.description',
        highlighted: true,
        inheritsFrom: 'upgrade_to_dashbo.plans.agency.name',
        prices: {
            usd: { monthly: 200, trimestral: 180, semestral: 160, yearly: 140 },
            ars: { monthly: 327904, trimestral: 295114, semestral: 262323, yearly: 229533 },
        },
        features: {
            adAccounts: 150,
            urlChecks: 50,
            sheetExports: 70,
            budgets: null,
            multiCurrency: true,
            adminUsers: true,
            flexIndicators: true,
            chatAlerts: true,
            adgroupLevel: true,
            multiAgencies: true,
            customerSuccess: true,
            training: true,
            apiAccess: false,
            portalClientes: 50,
        },
        displayFeatures: [
            { key: 'ad_accounts', labelKey: 'subscription_features.ad_accounts_150', included: true },
            { key: 'url_checks', labelKey: 'subscription_features.url_checks_50', included: true },
            { key: 'sheet_exports', labelKey: 'subscription_features.sheet_exports_70', included: true },
            { key: 'adgroup_level', labelKey: 'subscription_features.adgroup_level', included: true },
            { key: 'partial_budget_goals', labelKey: 'subscription_features.partial_budget_goals', included: true },
            { key: 'multi_agencies', labelKey: 'subscription_features.multi_agencies', included: true },
            { key: 'customer_success', labelKey: 'subscription_features.customer_success', included: true },
            { key: 'dashbo_connect', labelKey: 'subscription_features.dashbo_connect', included: true, highlight: true, type: 'callout', subtitleKey: 'subscription_features.dashbo_connect_subtitle' },
            { key: 'portal_clientes', labelKey: 'subscription_features.portal_clientes_50', included: true, highlight: true, type: 'callout', subtitleKey: 'subscription_features.portal_clientes_subtitle' },
        ],
    },
    {
        id: 'epic_agency',
        nameKey: 'upgrade_to_dashbo.plans.epic_agency.name',
        descriptionKey: 'upgrade_to_dashbo.plans.epic_agency.description',
        inheritsFrom: 'upgrade_to_dashbo.plans.big_agency.name',
        prices: {
            usd: { monthly: 350, trimestral: 315, semestral: 280, yearly: 245 },
            ars: { monthly: 515590, trimestral: 464031, semestral: 412472, yearly: 360913 },
        },
        features: {
            adAccounts: 300,
            urlChecks: 50,
            sheetExports: 140,
            budgets: null,
            multiCurrency: true,
            adminUsers: true,
            flexIndicators: true,
            chatAlerts: true,
            adgroupLevel: true,
            multiAgencies: true,
            customerSuccess: true,
            training: true,
            apiAccess: true,
            portalClientes: 100,
        },
        displayFeatures: [
            { key: 'ad_accounts', labelKey: 'subscription_features.ad_accounts_300', included: true },
            { key: 'sheet_exports', labelKey: 'subscription_features.sheet_exports_140', included: true },
            { key: 'api_access', labelKey: 'subscription_features.api_access', included: true },
            { key: 'portal_clientes', labelKey: 'subscription_features.portal_clientes_100', included: true, highlight: true, type: 'callout', subtitleKey: 'subscription_features.portal_clientes_subtitle' },
        ],
    },
];

export function formatPrice(price, currency) {
    return price.toLocaleString('es-AR', { minimumFractionDigits: 0, maximumFractionDigits: 0 });
}

export function getPrice(plan, currency, period) {
    return plan.prices[currency.toLowerCase()][period];
}
